import React from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import Table from 'react-bootstrap/Table'
import './SummaryTable.css'

const SummaryTable = ({ 
  files, userInfo, groupInfo, reviewInfo, reviewAssignInfo = { reviewers:[] } }) => {
    
  const getReviewerProgress = (userId) => {
    let result = '';
    if (reviewInfo.type === 'output') {
      result = getOutputReviewerProgress(userId);
    } else if (reviewInfo.type === 'doc') {
      result = getDocReviewerProgress(userId);
    }
    return result;
  };
  
  const getOutputReviewerProgress = (userId) => {
  	let total = files.length || 0;
  	let countResult = _.filter(reviewInfo.summary, function (info) { 
  		if (info.user_id === userId) {
  			return info.count;
  		}
  	});
    let completeCount = 0;
    if (countResult && countResult.length > 0) {
      completeCount = countResult[0].count;
    }
  	let result = completeCount + ' / ' + total;
  	return result;
  };
  
  const getDocReviewerProgress = (userId) => {
    let total = 0;
    let reviewedPageCount = 0;
    _.map(reviewInfo.summary, (data) => {
      if (data.userId === userId) {
        // skip cancelled file
        if (data.status_id !== 2) {
          reviewedPageCount += data.pagesReviewed;
        }
      }
    });
    _.map(files, (file) => {
      // skip cancelled file=
      if (file.statusId !== 2) {
        total += file.pagesTotal;
      }
    });
    let result = reviewedPageCount + ' / ' + total;
    return result;
  };
  
  const getReviewersInfo = () => {
    let reviewers = _.map(reviewAssignInfo.reviewers, (reviewer) => {
      return { user_id:reviewer.userId };
    })
    reviewers = _.orderBy(reviewers, 'user_id', 'asc');
    console.log('getReviewersInfo reviewers:', reviewers);
    return reviewers;
  }
  
  const content = (
    <div>
      <Table responsive>
        <thead>
          <tr>
            <th>Reviewer</th>
            <th>Progress</th>
          </tr>
        </thead>
        <tbody>
          {getReviewersInfo().map((reviewer, index) => (
          <tr key={reviewer.user_id}>
            <td key="user">{reviewer.user_id}</td>
            <td key="progress" data-user={reviewer.user_id}>
              { getReviewerProgress(reviewer.user_id) }
            </td>
          </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
  return content;
}

const mapState = state => ({
  files: state.files,
  userInfo: state.userInfo,
  groupInfo: state.groupInfo,
  reviewInfo: state.reviewInfo,
  reviewAssignInfo: state.reviewAssignInfo,
})

const mapDispatch = dispatch => ({
  // startGetReviewAssignInfo: () => dispatch(getReviewAssigInfo()),
})

export default connect(mapState, mapDispatch)(SummaryTable);
